<div class="panel panel-main">
    <div class="panel-heading px-3">
        <h3 data-qa="qa-patient-title">{{ 'CLIENTS_TITLE' | translate }}</h3>
        <div class="panel-heading-keys">
            <span class="d-flex align-items-center" data-qa="qa-active-employees-label">
                |&nbsp; <b> {{ totalPatients }}</b>
            </span>
            <app-search placeholder="SEARCH" (search)="searchTextChange($event)"></app-search>
        </div>
    </div>
    <div class="panel-body px-3">
        <app-table
            class="patient-table"
            [loadingItems]="loading" [rowSelection]="true" [keyboardNavigation]="true">
            <ng-container header>
                <th class="flex-2" appHeaderSort="patientId" appTitleProvider>
                    <span>{{ 'CLIENT_ID' | translate }}</span>
                </th>
                <th class="flex-3" appHeaderSort="patientName" appTitleProvider>
                    <span>{{ 'NAME' | translate }}</span>
                </th>
                <th class="flex-4" appHeaderSort="streetAddressNameNumberAndLetter" appTitleProvider>
                    <span>{{ 'ADDRESS' | translate }}</span>
                </th>
                <th class="flex-1" appHeaderSort="status" appTitleProvider>
                    <span>{{ 'STATUS' | translate }}</span>
                </th>
            </ng-container>
            <ng-container body>
                @for (patient of patients; track patient.patientId) {
                    <tr [ngClass]="{ active: patient.selected }"
                        (click)="select(patient, $event)">
                        <td class="flex-2" appTitleProvider>
                            <span>{{ patient.patientId }}</span>
                        </td>
                        <td class="flex-3" appTitleProvider>
                            <span>{{ patient.patientName }}</span>
                        </td>
                        <td class="flex-4" appTitleProvider>
                            <span>{{ patient.streetAddressNameNumberAndLetter }}</span>
                        </td>
                        <td class="flex-1 justify-content-center">
                            @if (!patient.addressUpdating && !patient.taskUpdating && !patient.feasibilityReloading) {
                                <ng-container>
                                    @if (!patient.addressValid || patient.feasibilityError) {
                                        <app-tooltip appCustomPopover popoverType="error" placement="top"
                                                     popoverText="CLIENT_ERROR_INFO"
                                                     [adaptPlacement]="true">
                                            <ng-container icon>
                                                <span
                                                    class="vismaicon vismaicon-sm vismaicon-filled vismaicon-error"></span>
                                            </ng-container>
                                        </app-tooltip>
                                    }
                                    @if ((patient.zipCodeWarning || patient.feasibilityWarning) &&
                                    patient.addressValid && !patient.feasibilityError) {
                                        <app-tooltip appCustomPopover placement="left" popoverText="CLIENT_WARNING_INFO"
                                                     [adaptPlacement]="true"
                                                     popoverType="warning">
                                            <ng-container icon>
                                                <span
                                                    class="vismaicon vismaicon-sm vismaicon-filled vismaicon-warning"></span>
                                            </ng-container>
                                        </app-tooltip>
                                    }
                                </ng-container>
                            }
                            @if (patient.addressUpdating || patient.taskUpdating || patient.feasibilityReloading) {
                                <div class="spinner">
                                </div>
                            }
                        </td>
                    </tr>
                }
            </ng-container>
        </app-table>
    </div>
</div>
